export default class InventaireStocksLeveeController {
	static $inject = ['$stateParams', 'StocksCommunicationService', 'StocksService', 'notification', 'ModalService', '$uibModal'];

	constructor($stateParams, StocksCommunicationService, StocksService, notification, ModalService, $uibModal) {
		this.$stateParams = $stateParams;
		this.StocksCommunicationService = StocksCommunicationService;
		this.StocksService = StocksService;
		this.notification = notification;
		this.ModalService = ModalService;
		this.$uibModal = $uibModal;
		this.result = false;
	}

	async $onInit() {
		this.getTotal();
	}

	annuler() {
		this.modalInstance.close(this.result);
	}

	changeTotal() {
		this.result = true;
		this.getTotal();
	}

	getTotal() {
		let total = null;
		this.levee.tasVolumes.forEach(function (element) {
			if (element.volume) {
				total = total + element.volume;
			}
		}, this);
		this.levee.volume = total;
		this.levee.stockReleve = this.levee.volume * this.levee.densite;
		this.levee.ecart = this.levee.stockReleve - this.levee.stockTheorique;
	}
}
